import { ReviewOffer } from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import {
  SOLAR_PRODUCT_ID,
  STORAGE_ADDON_BUNDLE_ID,
  STORAGE_ADDON_PRODUCT_ID,
} from "constants/bundleAndProductIds";

type ShouldShowOfferReviewSystemComparisonArgs = {
  offer: ReviewOffer | undefined;
  nonSolarView: boolean;
  hasBattery: boolean;
};

const getOfferProductIds = (offer: ReviewOffer | undefined): string[] => {
  if (!offer) {
    return [];
  }

  return [...(offer.includedProducts ?? []), ...(offer.accessoryProducts ?? [])]
    .map((product) => product.productId)
    .filter(Boolean);
};

/** Full-system positioning (utility vs Sunrun house) — not for storage add-on or solar-only. */
const shouldShowOfferReviewSystemComparison = ({
  offer,
  nonSolarView,
  hasBattery,
}: ShouldShowOfferReviewSystemComparisonArgs): boolean => {
  if (!offer || nonSolarView) {
    return false;
  }

  const productIds = getOfferProductIds(offer);

  const hasStorageAddOn = productIds.some((id) =>
    [STORAGE_ADDON_PRODUCT_ID, STORAGE_ADDON_BUNDLE_ID].includes(id)
  );
  if (hasStorageAddOn) {
    return false;
  }

  const hasSolar = productIds.includes(SOLAR_PRODUCT_ID);
  if (!hasSolar || !hasBattery) {
    return false;
  }

  return true;
};

export { shouldShowOfferReviewSystemComparison };
